<template src="./HeaderSubtitle.html"></template>

<script>
import { psoriasis as menuItems } from '@/data/sections';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      menuItems,
      targetSubSection: 0
    };
  },
  computed: {
    ...mapState(['userAgent']),
    sectionName() {
      if (this.$store.getters.activeSubsection.name) {
        return this.$store.getters.activeSubsection.name;
      }
    },
    mobileScrollDuration() {
      if (this.userAgent.screentest) {
        return 1;
      } else {
        return 300;
      }
    },
    headerClass() {
      return {
        header__subsection: true,
        // expanded: this.subtitleState === 'scrolled',
        'header__subsection--sectionOpen':
          this.$store.state.headerStatus === 'menu',
        'full-section-title': this.subtitleState === 'scrolled',
        'submenu-opened': this.subtitleState === 'menu-auto',
        'header__subsection--tremfya-top':
          this.$store.getters.page === 'tremfya' &&
          this.subtitleState !== 'footer',
        'header__subsection--blue-footer':
          this.$store.getters.page === 'tremfya' &&
          this.subtitleState === 'footer'
      };
    }
  },
  components: {},
  name: 'header-subtitle',
  methods: {
    screenDependantOffset(num) {
      console.log(
        num,
        this.userAgent.device.isPhone,
        this.userAgent.device.isTablet
      );
      // let off = this.userAgent.device.isPhone ? -40 : 0;
      // if (
      //   this.$route.name.includes('Tremfya') &&
      //   (parseInt(num) === 4 || parseInt(num) === 5)
      // ) {
      //   off += this.userAgent.device.isPhone ? 30 : 0;
      // }
      // console.log('Offset for scroll', off);
      // return off;

      let offset = 0;

      if (this.userAgent.device.isPhone) {
        let imgs = document.querySelectorAll('.header__subsection > img');

        if (imgs.length > 0) {
          offset = -parseInt(imgs[imgs.length - 1].scrollHeight) + 10;
        }

        if (this.userAgent.window.width <= 320) {
          offset += 20;
        }
      }

      return offset;
    },
    setSection(obj) {
      this.$store.commit('setRouteFromParams', {
        name: this.$route.meta.page,
        params: {
          ...obj
        }
      });
    }
  },
  props: ['subtitleState', 'choosenSubmenuItems']
};
</script>
